import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Link = _resolveComponent("Link");
    const _component_el_icon = _resolveComponent("el-icon");
    const _component_el_button = _resolveComponent("el-button");
    const _component_el_input = _resolveComponent("el-input");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_input, {
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                placeholder: _ctx.placeholder || 'Input text here',
                disabled: _ctx.disabled,
                type: _ctx.type,
                onInput: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('input', $event)))
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                (_ctx.withRedirect)
                    ? {
                        name: "append",
                        fn: _withCtx(() => [
                            _createVNode(_component_el_button, {
                                link: "",
                                onClick: _ctx.redirectLink
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_Link)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "placeholder", "disabled", "type"])
        ]),
        _: 1 /* STABLE */
    }));
}
